import React from "react";
import { Divider, Grid, Typography } from "@material-ui/core";

import "../style.css";

const UserDetail = ({ label = "", value = "" }) => {
  return (
    <Grid item container justifyContent="space-between" className="mt-16">
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2" className="w-half">
        {value}
      </Typography>
    </Grid>
  );
};

const UserDetailsView = ({ userProfile = {} }) => {
  const fullName = `${userProfile?.personalInfo?.fname ?? ""} ${userProfile?.personalInfo?.lname ?? ""}`;

  return (
    <Grid
      item
      container
      direction="column"
      className="p-8 id-user-details-view"
    >
      <Typography className="font-weight-600">User Details</Typography>
      <Divider className="w-full" />
      <UserDetail label="Name" value={fullName} />
      <UserDetail
        label="Date of Birth"
        value={`${userProfile?.personalInfo?.dob ?? ""}`}
      />
    </Grid>
  );
};

export default UserDetailsView;
